import * as TYPES from './constants';
import {API, JSON_HEADER, JWT_HEADER} from 'config/srm.config';
import {
  // GET
  ListPartnerDirectoryError,
  receiveListPartnerDirectory,
  requestListPartnerDirectory,
  // ADD
  AddPartnerToDirectoryError,
  requestAddPartnerToDirectory,
  receiveAddPartnerToDirectory,
  // PATCH
  UpdatePartnerToDirectoryError,
  requestUpdatePartnerToDirectory,
  receiveListUpdatePartnerTODirectory,
  // DELETE
  DeletePartnerFromDirectoryError,
  requestDeletePartnerFromDirectory,
  receiveListDeletePartnerFromDirectory,
} from './actions';

const initialState = {
  data: null,
  error: false,
  request: false,
  updateRequest: false,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_LIST_OF_PARTNER_DIRECTORY:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_LIST_OF_PARTNER_DIRECTORY:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.LIST_OF_PARTNER_DIRECTORY_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.REQUEST_UPDATE_PARTNER_TO_DIRECTORY:
    case TYPES.REQUEST_DELETE_PARTNER_FROM_DIRECTORY:
      return {
        ...state,
        updateRequest: true,
      };
    case TYPES.UPDATE_PARTNER_TO_DIRECTORY_ERROR:
    case TYPES.DELETE_PARTNER_FROM_DIRECTORY_ERROR:
    case TYPES.RECEIVE_UPDATE_PARTNER_TO_DIRECTORY:
    case TYPES.RECEIVE_DELETE_PARTNER_FROM_DIRECTORY:
      return {
        ...state,
        updateRequest: false,
      };
    default:
      return state;
  }
};

export const fetchPartnerDirectoryList = params => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const {page = 1, pageSize = 10} = params || {};
  const config = {
    mode: 'cors',
    method: 'GET',
    cache: 'default',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
  };
  const URI = `${
    API.opportunityLink.partner_directory
  }?page=${page}&page_size=${pageSize}`;

  dispatch(requestListPartnerDirectory());
  try {
    return fetch(URI, config)
      .then(response => response.json())
      .then(json => {
        dispatch(receiveListPartnerDirectory(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(ListPartnerDirectoryError(err));
      });
  } catch (err) {
    console.log('PartnerDirectory Error', err);
    dispatch(ListPartnerDirectoryError(err));
  }
};

export const addPartnerToDirectoryList = (list, callback) => (
  dispatch,
  getState
) => {
  const {
    auth: {
      access: {token},
    },
    instance: {
      data: {institution_id},
    },
  } = getState();

  const body = {
    partner_id: institution_id, // partner uuid
    institution_id: list, // institutions uuids list
  };

  const config = {
    method: 'POST',
    body: JSON.stringify(body),
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
  };
  const endpoint = `${API.opportunityLink.partner_directory}`;

  dispatch(requestAddPartnerToDirectory());
  try {
    return fetch(endpoint, config)
      .then(response => response.json())
      .then(async json => {
        dispatch(receiveAddPartnerToDirectory());
        await dispatch(fetchPartnerDirectoryList());
        callback && callback(json);
      })
      .catch(async err => {
        console.log('AddPartnerToDirectory Err', err);
        dispatch(AddPartnerToDirectoryError(err));
        await dispatch(fetchPartnerDirectoryList());
        callback && callback(err);
      });
  } catch (err) {
    console.log('AddPartnerToDirectory Err', err);
    dispatch(AddPartnerToDirectoryError(err));
  }
};

export const updatePartnerToDirectoryList = (
  partner_directory_uuid,
  body,
  callback
) => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();

  const config = {
    method: 'PATCH',
    body: JSON.stringify(body),
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
  };
  const endpoint = `${
    API.opportunityLink.partner_directory
  }${partner_directory_uuid}`;

  dispatch(requestUpdatePartnerToDirectory());
  try {
    return fetch(endpoint, config)
      .then(response => response.json())
      .then(async json => {
        callback && callback(json);
        dispatch(receiveListUpdatePartnerTODirectory());
        await dispatch(fetchPartnerDirectoryList());
      })
      .catch(async err => {
        console.log('UpdatePartnerToDirectory Err', err);
        dispatch(UpdatePartnerToDirectoryError(err));
        await dispatch(fetchPartnerDirectoryList());
      });
  } catch (err) {
    console.log('UpdatePartnerToDirectory Err', err);
    dispatch(UpdatePartnerToDirectoryError(err));
  }
};

export const deletePartnerFromDirectory = partner_directory_uuid => (
  dispatch,
  getState
) => {
  const {
    auth: {
      access = {},
      access: {token},
    },
  } = getState();

  const config = {
    method: 'DELETE',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
  };
  const endpoint = `${
    API.opportunityLink.partner_directory
  }${partner_directory_uuid}`;

  dispatch(requestDeletePartnerFromDirectory());
  try {
    return fetch(endpoint, config)
      .then(response => response.json())
      .then(async json => {
        dispatch(receiveListDeletePartnerFromDirectory());
        await dispatch(fetchPartnerDirectoryList());
      })
      .catch(async err => {
        console.log('DeletePartnerToDirectory', err);
        dispatch(DeletePartnerFromDirectoryError(err));
        await dispatch(fetchPartnerDirectoryList());
      });
  } catch (err) {
    console.log('DeletePartnerToDirectory', err);
    dispatch(DeletePartnerFromDirectoryError(err));
  }
};
